import { Task } from '@models/task.model';

// Progress calculation borrowed from TimelineCard
export const progressValueCalculation = (task: Task) => {
  if (!task?.startTime || !task?.endTime) return 0;
  const parsedStart =
    typeof task.startTime === 'string'
      ? new Date(task.startTime)
      : task.startTime;
  const parsedEnd =
    typeof task.endTime === 'string' ? new Date(task.endTime) : task.endTime;
  const now = new Date();
  const startMs = parsedStart instanceof Date ? parsedStart.getTime() : NaN;
  const endMs = parsedEnd instanceof Date ? parsedEnd.getTime() : NaN;
  let value = 0;
  if (Number.isFinite(startMs) && Number.isFinite(endMs) && endMs > startMs) {
    const ratio = (now.getTime() - startMs) / (endMs - startMs);
    value = Math.round(Math.min(1, Math.max(0, ratio)) * 100);
  }
  return value;
};
